import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FaInstagram, FaTiktok } from 'react-icons/fa6';
import './SocialStats.css';

const SocialStats: React.FC = () => {
  const { t } = useTranslation();

  // TikTok ve Instagram embed script'lerini yükle
  useEffect(() => {
    // TikTok script
    const tiktokScript = document.createElement('script');
    tiktokScript.src = 'https://www.tiktok.com/embed.js';
    tiktokScript.async = true;
    document.body.appendChild(tiktokScript);

    // Instagram script
    const instagramScript = document.createElement('script');
    instagramScript.src = '//www.instagram.com/embed.js';
    instagramScript.async = true;
    document.body.appendChild(instagramScript);

    return () => {
      document.body.removeChild(tiktokScript);
      document.body.removeChild(instagramScript);
    };
  }, []);

  return (
    <section className="social-stats section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="social-stats-header"
        >
          <h2 className="section-title">{t('socialStats.title')}</h2>
          <p className="section-subtitle">{t('socialStats.subtitle')}</p>
        </motion.div>

        <div className="social-embeds-container">
          {/* Instagram Embed */}
          <motion.div 
            className="social-embed-column"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <div className="embed-card instagram-card">
              <div className="embed-header instagram-header">
                <FaInstagram className="embed-header-icon" />
                <div className="embed-header-info">
                  <h3>Instagram</h3>
                  <span>@ustaconsulting</span>
                </div>
                <div className="embed-stats-badge">
                  <span className="embed-stat-value">15.3K</span>
                  <span className="embed-stat-label">{t('socialStats.followers')}</span>
                </div>
              </div>
              <div className="embed-wrapper instagram-embed-wrapper">
                <blockquote 
                  className="instagram-media" 
                  data-instgrm-captioned 
                  data-instgrm-permalink="https://www.instagram.com/reel/DS2mb_9DVd8/?utm_source=ig_embed&amp;utm_campaign=loading" 
                  data-instgrm-version="14"
                >
                  <div style={{ padding: '16px' }}>
                    <a 
                      href="https://www.instagram.com/reel/DS2mb_9DVd8/?utm_source=ig_embed&amp;utm_campaign=loading" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ background: '#FFFFFF', lineHeight: 0, padding: 0, textAlign: 'center', textDecoration: 'none', width: '100%' }}
                    >
                      Bu gönderiyi Instagram'da gör
                    </a>
                    <p style={{ color: '#c9c8cd', fontFamily: 'Arial,sans-serif', fontSize: '14px', lineHeight: '17px', marginBottom: 0, marginTop: '8px', overflow: 'hidden', padding: '8px 0 7px', textAlign: 'center', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      <a 
                        href="https://www.instagram.com/reel/DS2mb_9DVd8/?utm_source=ig_embed&amp;utm_campaign=loading" 
                        style={{ color: '#c9c8cd', fontFamily: 'Arial,sans-serif', fontSize: '14px', fontStyle: 'normal', fontWeight: 'normal', lineHeight: '17px', textDecoration: 'none' }} 
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Usta Consulting (@ustaconsulting)'in paylaştığı bir gönderi
                      </a>
                    </p>
                  </div>
                </blockquote>
              </div>
            </div>
          </motion.div>

          {/* TikTok Embed */}
          <motion.div 
            className="social-embed-column"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <div className="embed-card tiktok-card">
              <div className="embed-header tiktok-header">
                <FaTiktok className="embed-header-icon" />
                <div className="embed-header-info">
                  <h3>TikTok</h3>
                  <span>@ustaconsulting</span>
                </div>
                <div className="embed-stats-badge">
                  <span className="embed-stat-value">55K</span>
                  <span className="embed-stat-label">{t('socialStats.followers')}</span>
                </div>
              </div>
              <div className="embed-wrapper tiktok-embed-wrapper">
                <blockquote 
                  className="tiktok-embed" 
                  cite="https://www.tiktok.com/@ustaconsulting/video/7589304043873258773" 
                  data-video-id="7589304043873258773"
                >
                  <section>
                    <a target="_blank" rel="noopener noreferrer" title="@ustaconsulting" href="https://www.tiktok.com/@ustaconsulting?refer=embed">@ustaconsulting</a>
                    <p>Usta ailesi olarak yeni yılınız kutlu olsun. 🎉</p>
                    <a target="_blank" rel="noopener noreferrer" title="♬ Originalton - ustaconsulting" href="https://www.tiktok.com/music/Originalton-7589304070707170055?refer=embed">♬ Originalton - ustaconsulting</a>
                  </section>
                </blockquote>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SocialStats;
